import { constants, date } from '@eti/utils';
import { addDays } from 'date-fns';

const { ageTypes } = constants;

export const getNumberOfAdults = (travelers) =>
  travelers.filter((traveler) => traveler.ageType === ageTypes.ADULT).length;

export const createBookingDeeplink = (
  arrivalDate,
  returnDate,
  cityCode,
  numberOfAdults,
  numberOfChildren,
  language,
  siteCurrency,
  label,
) => {
  const AID = 2164554;
  const checkinYear = date.format(arrivalDate, 'yyyy');
  const checkinMonth = date.format(arrivalDate, 'M');
  const checkinDay = date.format(arrivalDate, 'd');
  const checkoutDate = returnDate ?? addDays(new Date(arrivalDate), 7);
  const checkoutYear = date.format(checkoutDate, 'yyyy');
  const checkoutMonth = date.format(checkoutDate, 'M');
  const checkoutDay = date.format(checkoutDate, 'd');

  const params = {
    aid: AID,
    checkin_year: checkinYear,
    checkin_month: checkinMonth,
    checkin_monthday: checkinDay,
    checkout_year: checkoutYear,
    checkout_month: checkoutMonth,
    checkout_monthday: checkoutDay,
    label,
    iata_orr: 1,
    iata: cityCode,
    lang: language,
    selected_currency: siteCurrency,
    group_adults: numberOfAdults,
    group_children: numberOfChildren,
  };

  const queryString = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');

  return `https://booking.com/searchresults.html?${queryString}`;
};

export const resolveDeepLinkToBooking = (
  bounds = [],
  language,
  siteCurrency,
  travelers = [],
  label,
) => {
  const firstBound = bounds[0];
  const secondBound = bounds[1];
  const allSegments = firstBound?.segments ?? [];
  const lastSegment = allSegments[allSegments.length - 1];
  const arrivalDate = lastSegment?.arrivedAt;
  const returnDate = secondBound?.segments[0]?.departuredAt;
  const city = lastSegment?.destination?.cityCode;
  const numberOfAdults = getNumberOfAdults(travelers);
  const numberOfChildren = travelers?.length - numberOfAdults;

  return createBookingDeeplink(
    arrivalDate,
    returnDate,
    city,
    numberOfAdults,
    numberOfChildren,
    language,
    siteCurrency,
    label,
  );
};
